<template>
  <div class="spaceCenter common">
    <!-- 融资确认 -->
    <div>
      <!-- <div class="spaceLeft item-box">
        <label>保理商</label>
        <span class="text-color-blue" style="margin-right:5px;">{{modalData.tenantName}} </span> 
      </div> -->
      <div class="spaceLeft item-box">
        <label>融资金额：</label>
        <span class="text-color-gold" style="margin-right:5px;">{{modalData.applyAmt | splitK}} </span> 元
      </div>
      <div class="spaceLeft item-box">
        <label>交易密码：</label>
        <a-input type="password" v-model="txnPwd" class="item-input" />
      </div>
      <div class="spaceCenter model-footer-btns">
        <a-button class="btn-big" @click="modalCancel">取消</a-button>
        <a-button
          class="btn-big"
          type="primary"
          @click="modalOk"
          :loading="modalLoad"
          :disabled="!txnPwd"
        >确定</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyTradePassword } from "@/api/gold.js";
export default {
  props: ["modalData"],
  name: "goldPayModal",
  data() {
    return {
      modalLoad: false,
      txnPwd: ""
    };
  },
  computed: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    modalOk(e) {
      this.modalLoad = true;
      let params = { tradePassword: this.txnPwd };
      verifyTradePassword(params)
        .then((res) => {
            let p = {
                gldListStr:JSON.stringify(this.modalData.list),
                txnPwd:this.utils.getPasswordEncryptString(this.txnPwd),
                recPersonInfo:JSON.stringify(this.modalData.recPersonInfo)
            };
            this.$emit("ok",this.utils.getPasswordEncryptString(this.txnPwd));
        })
        .catch((error) => {
            this.modalLoad = false;
            console.log(err);
        });
    },
    modalCancel(e) {
      this.modalLoad = false;
      this.$emit("cancel");
    }
  }
};
</script>
<style scoped>
    .item-box > label {
        min-width: 70px;
    }
    .item-box {
        margin: 0 15px 15px 0;
        
    }
    .item-input {
        width: 200px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/finance-password-modal.vue